import React, { useEffect, useState } from 'react'
import { Accordion, Button, Form, Modal } from 'react-bootstrap'
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import _ from "underscore"
import CreatableSelect from "react-select/creatable";

export default function VehicleInfo() {
    const searchParams = new URLSearchParams(window.location.search)
    const [loading, setLoading] = useState(true)
    const [list, setlist] = useState({})
    const [options, setOptions] = useState([])
    const [options2, setOptions2] = useState([])
    const [modal, setModal] = useState({
        data: {},
        show: false,
        type: "",
        title: ""
    })
    const [value, setValue] = useState({})


    const getList = () => {
        Api.GetApi(endPoints.VEHICLE_INFORMATION).then(res => {
            setLoading(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    // setlist(res.data.data.data || [])

                    let arr2 = []
                    let arr3 = []
                    res.data.data.data.map((cat, i) => {
                        arr2.push({ value: cat.model, label: cat.model })
                    })
                    setOptions2(arr2)

                    let arr = _.groupBy(res.data.data.data, "brand")
                    Object.keys(arr).map((key) => {
                        arr3.push({ value: key, label: key })
                    })
                    setOptions(arr3)
                    setlist(Object.keys(arr).map((key) => {
                        return {
                            brand: key,
                            model: arr[key]
                        }
                    }))
                    handleClose()
                }
            }
        })
    }

    const handleClose = () => {
        setModal({
            ...modal,
            data: {},
            show: false,
            type: "",
            title: ""
        })
        setValue({})
    }

    const addNew = () => {
        setModal({
            ...modal,
            show: true,
            type: "add",
            title: "Add new"
        })
    }

    const handleSubmit = () => {
        if (!value.brand || !value.model) {
            return Api.Alert("Please fill all required fields", "error")
        }
        let data = {
            "brand": value.brand || "",
            "model": value.model || "",
        }
        Api.PostApi(endPoints.VEHICLE_INFORMATION, data).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    Api.Alert("Added successfully!", "success")
                    getList()
                }
            }
        })
    }
    const handleConfirm = () => {
        if (modal.data && modal.data._id) {
            Api.DeleteApi(`${endPoints.VEHICLE_INFORMATION}/${modal.data._id}`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    Api.Alert(res.data.data, "success")
                    getList()
                }
            })
        }
    }

    const showModal = (data, type) => {
        if (type === "edit") {
            setValue({ ...value, ...data })
        }
        setModal({
            ...modal,
            data: data,
            show: true,
            type: type,
        })
    }
    console.log("value", value)

    useEffect(() => {
        getList()
    }, [])

    return (
        <>
            {loading ?
                <div className="loader-line"></div> :
                <main id="main" className="main">
                    <div className="pagetitle pagetitleFilters d-flex flex-wrap  justify-content-between align-items-start">
                        <h1>Vehicle Information</h1>
                        <Button variant="primary" size='sm' className='me-2 align-items-center' onClick={addNew} >+Add New</Button>
                    </div>
                    <div className="card">
                        <div className="card-body ">
                            <Accordion defaultActiveKey="0">
                                {list.length > 0 ?
                                    <>
                                        {list.map((item, index) => (
                                            <Accordion.Item eventKey={index} key={index}>
                                                <Accordion.Header>
                                                    <div className='custom_accordion_button'>
                                                        <strong>{item?.brand}</strong>

                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="inline-container carousel_slider_container">
                                                        {item.model.map((model, ind) => (
                                                            <div key={ind} className='carousel_slider p-3'>
                                                                <div className='custom_accordion_button p-0'>
                                                                    <strong>{model.model}</strong>
                                                                    <div>
                                                                        <button className='btn btn-sm btn-outline-success ms-2' onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            showModal(model, "edit")
                                                                        }}><Icon.PencilFill /></button>
                                                                        <button className='btn btn-sm btn-outline-danger ms-2' onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            showModal(model, "delete")
                                                                        }}><Icon.TrashFill /></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </>
                                    :
                                    <h5>No Records Found</h5>
                                }
                            </Accordion>
                        </div>
                    </div>

                    <Modal show={modal.show} centered size='md' onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='h5 modalTitleCstm'> {modal.title} </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {modal.type === "add" || modal.type === "edit" ? <>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Brand</strong></label>
                                        <CreatableSelect
                                            options={options}
                                            placeholder="Select or create..."
                                            isClearable
                                            value={
                                                options.find(option => option.value === value.brand) ||
                                                (value.brand
                                                    ? {
                                                        value: value.brand,
                                                        label: value.brand
                                                    }
                                                    : null)
                                            }
                                            onChange={(selectedOption) => {
                                                setValue(prev => ({
                                                    ...prev,
                                                    brand: selectedOption?.value || ""
                                                }));
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Model</strong></label>
                                        <CreatableSelect
                                            options={options2}
                                            placeholder="Select or create..."
                                            isClearable
                                            value={
                                                options2.find(option => option.value === value.model) ||
                                                (value.model
                                                    ? {
                                                        value: value.model,
                                                        label: value.model
                                                    }
                                                    : null)
                                            }
                                            onChange={(selectedOption) => {
                                                setValue(prev => ({
                                                    ...prev,
                                                    model: selectedOption?.value || ""
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}>
                                        Save
                                    </button>
                                </div>
                            </> : null}
                            {modal.type == "delete" && <>
                                <div className='text-center mb-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to delete this model.</h5>
                                </div>
                                <div className='text-center mt-2'>
                                    <button className='btn btn-danger btn-sm me-3' onClick={handleConfirm}> Confirm</button>
                                    <button className='btn btn-outline-danger btn-sm' onClick={handleClose} > Cancel</button>
                                </div>
                            </>}

                        </Modal.Body>
                    </Modal>

                </main>
            }
        </>
    )
}
